import React, { FC } from 'react';
import { Heading, Text, TextButton } from '@wix/design-system';
import { ExternalLink } from '@wix/wix-ui-icons-common';
import { tabsByIdMapper } from '../../../utils/mappers';
import css from '../TemplatesMainPage.scss';
import { useTranslation } from '@wix/wix-i18n-config';
import { DataHooks } from '../../../constants/dataHooks';
import { DOCS } from '../../../constants/routes';
import { useTabs } from '../../../hooks/useTabs';
import { useTemplatesPageBi } from '../../../hooks/useTemplatesPageBi';

export const TemplatesGridHeading: FC = () => {
  const { t } = useTranslation();
  const { activeTabId } = useTabs();
  const tab = tabsByIdMapper[activeTabId];
  const { reportClickOnDocs } = useTemplatesPageBi();

  const onDocsLinkClick = () => {
    reportClickOnDocs(activeTabId as string);
    window.open(DOCS[activeTabId]);
  };

  return (
    <div className={css.templatesGridHeadingWrapper}>
      <Heading dataHook={DataHooks.GridTitle} size="large">
        {t(tab.gridTitleKey!)}
      </Heading>
      <div className={css.subtitleAndDocLinkWrapper}>
        <Text dataHook={DataHooks.GridSubtitle}>{t(tab.gridSubtitleKey!)}</Text>
        <TextButton
          dataHook={DataHooks.GridDocs}
          onClick={onDocsLinkClick}
          suffixIcon={<ExternalLink />}
        >
          {t(tab.gridDocsKey!)}
        </TextButton>
      </div>
    </div>
  );
};
